import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Button,
  Flex,
} from "@chakra-ui/react";
import { Dispatch, FC, SetStateAction } from "react";
import { TableConfig } from "../../../types/Components/Table/TableConfig";
import ModalBodyIndicator from "./ModalBodyIndicator";
import ModalBodyOccurrenceManual from "./ModalBodyOccurrenceManual";
import ModalBodyOccurrenceSystem from "./ModalBodyOccurrenceSystem";
import { ModalConfig } from "../../../types/Components/Modal/ModalConfig";
import { handleSubmitItem } from "../../../helpers/handleSubmitItem";
import api from "../../../utils/api";
import { Toast } from "../../../components/atom/Toast/Toast";
import { OCCURENCE_FINISH } from "../../../utils/endpoints";
import { PaginationConfig } from "../../../types/Components/Table/PaginationConfig";
import { AuthUser } from "../../../types/User/AuthUser";

interface ModalFieldOccurrencesProps {
  control: any;
  tableConfig: TableConfig;
  paginationConfig: PaginationConfig;
  modalConfig: ModalConfig;
  setIsSearching: Dispatch<SetStateAction<boolean>>;
  user: AuthUser;
  isHistoryLoaded: boolean;
}

const ModalFieldOccurrences: FC<ModalFieldOccurrencesProps> = ({
  control,
  tableConfig,
  paginationConfig,
  modalConfig,
  setIsSearching,
  user,
  isHistoryLoaded,
}) => {
  const { isOpen, title = "", buttonTitle, closeModal } = modalConfig;
  const { addToast } = Toast();

  const handleSolveOccurrence = async () => {
    const success = await handleSubmitItem(
      () => api.patch(`${OCCURENCE_FINISH}/${control._formValues.row?.id}`),
      addToast,
    );

    if (success) {
      closeModal();
    }

    setIsSearching(true);
  };

  const modalContentProps =
    control._formValues.row?.origin === "Sistema" ? { maxW: "80vw" } : {};

  return (
    <Modal isOpen={isOpen} onClose={closeModal} isCentered size="6xl">
      <ModalOverlay />
      <ModalContent {...modalContentProps}>
        <ModalHeader fontSize="xl" fontWeight="bold">
          {title}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb="4">
          {control._formValues.row?.origin === "Manual" ? (
            <ModalBodyOccurrenceManual control={control} />
          ) : (
            <Flex direction="column" gap="8">
              <ModalBodyOccurrenceSystem control={control} />
              {control._formValues.row?.indicator && (
                <ModalBodyIndicator
                  control={control}
                  tableConfig={tableConfig}
                  paginationConfig={paginationConfig}
                  isHistoryLoaded={isHistoryLoaded}
                />
              )}
            </Flex>
          )}
        </ModalBody>
        <ModalFooter>
          <Flex justifyContent="space-between" width="100%">
            {control._formValues.row?.origin === "Manual" &&
              control._formValues.row?.isActive &&
              control._formValues.row?.type?.name === "Alerta" &&
              user?.permissions &&
              user.permissions.includes("EnableOccurrences") && (
                <Button
                  onClick={handleSolveOccurrence}
                  variant="secondary"
                  colorScheme="green"
                >
                  Resolver ocorrência
                </Button>
              )}

            <Button onClick={closeModal}>{buttonTitle}</Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalFieldOccurrences;
